import { ResumeMainPage } from '../ResumeMainPage'
import { WorkExperience } from './WorkExperience.tsx'

export function WorkExperiencePage() {
    return (
        <ResumeMainPage index="Work_Experience">
            <WorkExperience />
        </ResumeMainPage>
    )
}
